import { s } from '@search/router/src/schema';
import { SusaninRoute } from '@search/router/src/susanin/SusaninRoute';
import { Tokens } from '@search/router/src/RouterInterfaces';

import { developerLandingMapper } from '@search/offer-search-routes/src/mappers/newBuilding/mappers';

import type { INewBuildingRouterContext as IRouterContext } from '../types';

export const DeveloperLandingType = s.rec({
    developerId: developerLandingMapper.Type,
    developerName: developerLandingMapper.SeoType
});

export type IDeveloperLandingType = ReturnType<typeof DeveloperLandingType>

export const DeveloperLandingSeoType = s.rec({
    origin: s.nullOpt(s.str),
    developerName: developerLandingMapper.SeoType
});

export type IDeveloperLandingSeoType = ReturnType<typeof DeveloperLandingSeoType>

export const developerLandingDefaults = {} as const;

export class DeveloperLandingRoute extends SusaninRoute<
    IDeveloperLandingSeoType,
    IDeveloperLandingType,
    IRouterContext,
    typeof developerLandingDefaults
> {
    displayName = 'DeveloperLandingRoute';

    protected metadata = DeveloperLandingSeoType.config;

    protected pattern(p: Tokens<IDeveloperLandingSeoType>) {
        return `${this.patternHost()}/${p.developerName}/`;
    }

    protected conditions() {
        return {
            ...super.conditions(),
            developerName: developerLandingMapper.keys
        };
    }

    defaults() {
        return developerLandingDefaults;
    }

    protected fromQuery({ developerName }: IDeveloperLandingSeoType) {
        return DeveloperLandingType({
            developerId: developerLandingMapper.typeFromSeo(developerName),
            developerName
        });
    }

    protected toQuery({ developerId }: IDeveloperLandingType) {
        return DeveloperLandingSeoType({
            developerName: developerLandingMapper.seoFromType(developerId)
        });
    }
}
